import axios from 'axios';
import { backend_server_address } from '../backendServer';
import { withOfflineCache } from '../capacitor/offlineCache';
import { createHttpPort } from '../chat/platform/http';
import { startAccess, withAccessToken } from './accessToken';
import { httpPortAdapter } from './axiosAdapter';

const network = createHttpPort();

/** The app's one transport. Axios and the chat core both send through it. */
export const appHttp = withOfflineCache(withAccessToken(network));

/** At boot, after the auth state listens for refresh outcomes: route axios here and start the session. */
export const installAppHttp = (): void => {
    axios.defaults.adapter = httpPortAdapter(appHttp);
    void startAccess(network, `${backend_server_address}/api/login/token2/refresh/`);
};
